module.exports = __webpack_public_path__ + "static/media/7.60839d34.jpg";